/**
 * URL 스킴 중화(neutralize) — 렌더/내보내기 경계 공용 방어(XSS).
 *
 * 정책(blocklist): 위험 스킴만 차단하고 나머지(상대경로·mailto·tel·http(s)·blob·data:image)는 보존.
 *  - javascript: / vbscript: -> "" (스크립트 실행 벡터)
 *  - data:<image 외> (예: data:text/html) -> "" — data:image/* 는 허용(붙여넣기/이미지 정합)
 *  - 제어문자(탭/개행 등)는 브라우저가 URL 파싱 시 제거해 우회가 가능하므로 선제거.
 *
 * 대화형 입력(link-toolbar)의 allowlist(SAFE_URL)보다 느슨하지만, 저장 JSON·마크다운·붙여넣기로
 * 유입되는 링크의 상대경로 등 정상 값을 보존하면서 알려진 앵커 XSS를 차단한다.
 */

/** 제어문자(0x00-0x1F, 0x7F) 제거 — 브라우저 URL 파서가 무시하므로 스킴 검사 전에 제거. */
function stripControlChars(str) {
  let out = "";
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    if (code <= 31 || code === 127) continue;
    out += str[i];
  }
  return out;
}

export function neutralizeUrl(url) {
  const s = stripControlChars(String(url == null ? "" : url)).trim();
  if (!s) return "";
  if (/^(?:javascript|vbscript):/i.test(s)) return "";
  if (/^data:(?!image\/)/i.test(s)) return ""; // data:image/* 만 허용
  return s;
}

/**
 * 임베드 제공자 화이트리스트 — YouTube/Vimeo 만. watch/공유 URL → 안전한 embed URL 로 변환.
 * 화이트리스트 밖(또는 파싱 실패)이면 null → 호출부는 카드/링크로 폴백(임의 URL iframe 금지: 클릭재킹·XSS 방어).
 * @returns {{ provider:string, id:string, embedUrl:string, ratio:string } | null}
 */
export function resolveEmbed(url) {
  const s = stripControlChars(String(url == null ? "" : url)).trim();
  if (!s) return null;
  let m;
  // YouTube: youtu.be/ID · youtube.com/watch?v=ID · /embed/ID · /shorts/ID (도메인 정확 매칭)
  m = s.match(/^(?:https?:\/\/)?(?:www\.|m\.)?(?:youtube\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/i);
  if (m) return { provider: "youtube", id: m[1], embedUrl: `https://www.youtube.com/embed/${m[1]}`, ratio: "16:9" };
  // Vimeo: vimeo.com/ID · player.vimeo.com/video/ID
  m = s.match(/^(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/(?:video\/)?(\d{6,})/i);
  if (m) return { provider: "vimeo", id: m[1], embedUrl: `https://player.vimeo.com/video/${m[1]}`, ratio: "16:9" };
  return null;
}

/** embedUrl 호스트가 허용 제공자인지 — 렌더 직전 iframe src 최종 방어(저장 JSON 변조 대비). */
export function isAllowedEmbedUrl(embedUrl) {
  const s = stripControlChars(String(embedUrl == null ? "" : embedUrl)).trim();
  return /^https:\/\/(?:www\.youtube\.com\/embed\/|player\.vimeo\.com\/video\/)/i.test(s);
}
